exports = module.exports = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdf-viewer .pdf-manage {\n  position: fixed;\n  bottom: 22px;\n  left: 0px;\n  z-index: 9;\n  width: 100%;\n  padding: 0 7%;\n  text-align: center;\n}\n.pdf-viewer .pdf-manage button {\n  background: #e93666;\n}", ""]);

// exports
